import { UserInterface } from '../interfaces/user';
import { Role } from './role';
import { Pa } from "./pa";

export class User implements UserInterface {
    id_user?: number;
    username: string;
    password: string;
    fk_id_role: number;
    role: Role;
    fk_id_pa: number | null;
    pa: Pa;
    name: string;
    surname: string;
    email: string;
    tel: string
    active: boolean;

    constructor() {
        this.username = '';
        this.password = '';
        this.fk_id_role = 0;
        this.role = new Role();
        this.fk_id_pa = null;
        this.pa = new Pa();
        this.name = '';
        this.surname = '';
        this.email = '';
        this.tel = '';
        this.active = true;
    }
}